$(function() {

  /**
   * 第一階層が同じナビゲーションにカレント表示する。
   */
  var stGlobalNav = (function() {
    var currentClass = 'st-GlobalNav_Link-current';
    var dir = location.pathname.split("/");
    var url = '/' + dir[1] + '/';
    $('.st-GlobalNav_Link').each(function() {
      var $this = $(this);
      if($this.attr('href') === url) {
        $this.addClass(currentClass);
      } else if(url === '//') {
        $('.st-GlobalNav_Link[href="/"]').addClass(currentClass);
      }
    })
  })();


}());
